// Renders the leading icon + display name for a campaign or segment row.
//
// Resolution order:
//   1. If `row.icon` is a known lucide-react PascalCase export, render that
//      component. Display name = `row.name` with any legacy `:key ` prefix
//      stripped (mirrors parseItemIcon semantics so backfilled and legacy
//      rows render identically).
//   2. Otherwise (icon null/empty OR unknown name), delegate to the legacy
//      `parseItemIcon` shim. This is a time-boxed compatibility branch.
//
// TODO(icon-shim): delete the legacy branch when, on BOTH campaigns and
// segments:
//   SELECT count(*) WHERE icon IS NULL = 0
//   SELECT count(*) WHERE name LIKE ':%' = 0
// Observability: legacy uses surface as `[icon-shim]` console.warn below.

import * as LucideIcons from "lucide-react";
import { parseItemIcon } from "./itemIcon";

// Module-scope set: warning fires once per unique row.name per page load,
// not per render — prevents render-loop spam.
const __warnedLegacyNames = new Set();

export function getRowIcon(row, fallbackIcon) {
  const iconKey = row?.icon;
  if (iconKey && LucideIcons[iconKey]) {
    const raw = (row?.name ?? "").trim();
    const space = raw.indexOf(" ");
    const displayName = raw.startsWith(":")
      ? space > 0
        ? raw.slice(space + 1).trim()
        : ""
      : raw;
    return { Icon: LucideIcons[iconKey], displayName };
  }

  const key = row?.name ?? "(null)";
  if (!__warnedLegacyNames.has(key)) {
    __warnedLegacyNames.add(key);
    console.warn(
      "[icon-shim] legacy parseItemIcon path used for row.name=",
      key,
      "— backfill the row's icon column to remove this warning.",
    );
  }
  return parseItemIcon(row?.name ?? "", fallbackIcon);
}
